import React from 'react';

/**
 * variant="dark"  — logo sur fond clair (PinLogin, cartes)
 * variant="light" — logo sur fond rouge (topnav) : encadré blanc arrondi
 */
export default function FoLogo({ size = 40, variant = 'dark' }) {
  const img = (
    <img
      src={process.env.PUBLIC_URL + '/fo-logo.png'}
      alt="FO Réunion"
      style={{ width: size, height: size, objectFit: 'contain', display: 'block' }}
    />
  );

  if (variant === 'light') {
    return (
      <div style={{
        background: '#fff',
        borderRadius: 6,
        padding: 3,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        {img}
      </div>
    );
  }

  return img;
}
